"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PAGE_LIMIT = 25;
var PRODUCT_MAPPINGS_PAGE_ERROR = 'Error getting information about product mappings';
var ADD_MAPPING_ERROR = 'Error occured while adding mapping';
var MAPPING_ALREADEY_EXISTS = 'A mapping for that product already exists';
var INVALID_MAPPING_ERROR = 'Invalid Mapping';
var getBaseFields = function getBaseFields(model) {
  return {
    erpProductCode: {
      kind: !model.erpProductCode ? 'text' : 'static-text',
      label: 'ERP Product Code',
      validations: {
        required: true
      }
    }
  };
};
var getPackageFields = function getPackageFields() {
  return {
    bundleName: {
      kind: 'text',
      label: 'Bundle Name',
      validations: {
        required: true
      }
    },
    packageName: {
      kind: 'list',
      label: 'Package names',
      tooltip: 'These should be package names like "agenda"',
      kind_options: {
        item_kind: 'text'
      },
      validations: {
        required: true
      }
    }
  };
};

// prepare mapping model for the modal
var mappingToModal = function mappingToModal() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var model = _.clone(mapping);
  var fields = getBaseFields(model);
  var titleAction = model.erpProductCode ? 'Edit' : 'Add';
  var titleType;
  if (model.type === 'package') {
    titleType = 'Package Mapping';
    Object.assign(fields, getPackageFields());
  } else {
    titleType = 'Seat Mapping';
  }
  return {
    model: model,
    title: "".concat(titleAction, " ").concat(titleType),
    saveLabel: 'Save',
    fields: fields
  };
};

// from a model from the modal build a mapping
var modalToMapping = function modalToMapping(model, existingMapping) {
  if (existingMapping) {
    model._rev = existingMapping._rev;
  }
  return model;
};
var OrgProductMappings = /*#__PURE__*/function () {
  OrgProductMappings.$inject = ["$rootScope", "$scope", "modalService", "entitlementsService"];
  /* @ngInject */
  function OrgProductMappings($rootScope, $scope, modalService, entitlementsService) {
    _classCallCheck(this, OrgProductMappings);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.modalService = modalService;
    this.entitlementsService = entitlementsService;
  }

  /**
   * Initializes data
   *
   */
  return _createClass(OrgProductMappings, [{
    key: "$onInit",
    value: function $onInit() {
      this.getProductMappings();
    }

    /**
     * Fetches the entitlements product code mappings
     *
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getProductMappings",
    value: function getProductMappings() {
      var _this = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        first: true
      };
      if (this.loading) return;
      this.loading = true;
      return this.entitlementsService.getProductMappings(Object.assign(page, {
        limit: PAGE_LIMIT
      })).then(function (productMappingsPage) {
        // backwards compatibility, previously packageName was string as we could link product code
        // to only a single package, now it is an array
        var _iterator = _createForOfIteratorHelper(productMappingsPage.items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mapping = _step.value;
            var packageName = mapping.packageName;
            mapping.packageName = Array.isArray(packageName) ? packageName : [packageName];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.productMappingsPage = productMappingsPage;
      }).catch(function (err) {
        console.error(err);
        if (page.first) {
          _this.productMappingsPage = {
            error: PRODUCT_MAPPINGS_PAGE_ERROR
          };
        } else {
          _this.$rootScope.setFlashMessage(PRODUCT_MAPPINGS_PAGE_ERROR, 'danger');
        }
      }).finally(function () {
        _this.loading = false;
      });
    }

    /**
     * Opens a modal with for to allow user to create or edit a mapping, saves the mapping on submit
     */
  }, {
    key: "addMapping",
    value: function addMapping(existingMapping) {
      var _this2 = this;
      this.addMappingLoading = true;
      this.modalService.openModalWithForm(mappingToModal(existingMapping)).then(function (model) {
        (existingMapping.erpProductCode ? _this2.entitlementsService.editProductMapping(modalToMapping(model, existingMapping)) : _this2.entitlementsService.addProductMapping(modalToMapping(model))).then(function (data) {
          if (data.ok) {
            _this2.getProductMappings();
          } else {
            _this2.$rootScope.setFlashMessage(ADD_MAPPING_ERROR, 'danger');
          }
        }).catch(function (err) {
          if (err.data.error === 'MappingAlreadyExists') {
            _this2.$rootScope.setFlashMessage(MAPPING_ALREADEY_EXISTS, 'danger');
          } else if (err.data.error === 'InvalidMappingDocProperties') {
            _this2.$rootScope.setFlashMessage(INVALID_MAPPING_ERROR, 'danger');
          } else {
            _this2.$rootScope.setFlashMessage(ADD_MAPPING_ERROR, 'danger');
          }
        }).finally(function () {
          return _this2.addMappingLoading = false;
        });
      });
    }

    /**
     * Ask for confirmation and then remove the targeted mapping
     * @param {Object} product
     */
  }, {
    key: "removeMapping",
    value: function removeMapping(product) {
      var _this3 = this;
      if (window.confirm("Do you want to remove mapping to ".concat(product.erpProductCode, "? "))) {
        this.entitlementsService.removeProductMapping(product.erpProductCode)
        // refresh
        .then(function () {
          return _this3.getProductMappings();
        });
      }
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-product-mappings', ['backstage.services']).component('bsOrgProductMappings', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-product-mappings/org-product-mappings.html',
  controllerAs: 'vm',
  controller: OrgProductMappings
}).name;